// Generated by purs version 0.15.15
import * as Data_Argonaut_Decode_Error from "../Data.Argonaut.Decode.Error/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Fusion_Foreign_Data_NQValue from "../Fusion.Foreign.Data.NQValue/index.js";
var fromJsonDecodeError2 = function (dictNQValueMember) {
    var stringify = Fusion_Foreign_Data_NQValue.stringify(dictNQValueMember);
    return function (scheme) {
        return function (nqValue) {
            return function (error) {
                return {
                    scheme: scheme,
                    message: "An error occured while trying to parse json",
                    additionalInfo: new Data_Maybe.Just(stringify(nqValue) + (": " + Data_Argonaut_Decode_Error.printJsonDecodeError(error)))
                };
            };
        };
    };
};
export {
    fromJsonDecodeError2
};
